import utils from 'utils';
import { getModifyFlag } from './reservationSelectors';

/**
 * This selectors checks if the the current sign in should include
 * the `associateProfile` parameter in the call and returns a boolean.
 *
 * Profile should be associated for the following scenarios:
 * 1. Login in-res - covered by the `isResflow` flag
 * 2. Login in-res OCI - covered by the `isResflow` flag
 * 3. Out-res OCI - covered by the `isModify` flag
 * 4. True modify - covered by the `isModify` flag
 *
 * @param {Object} state An immutable state object to check against
 * @returns {boolean} - should the profile be associated with the reservation?
 */
export const shouldAssociateProfileSelector = state => {
  const isModify = getModifyFlag(state);
  const isResflow = utils.isReservationFlow();
  const shouldAssociate = !!(isModify || isResflow);
  return shouldAssociate;
};
